import { Rating } from '../types';

type Review = {
  rating: number | null;
  reviewNumber: number | null;
};

export function getRatingValue(ratings?: Rating | null, isGroupRating = false): Review {
  if (!ratings)
    return {
      rating: null,
      reviewNumber: null,
    };

  const { rating, reviewNumber, groupRating, groupReviewNumber, groupId } = ratings;

  if (isGroupRating && groupId) {
    return {
      rating: groupRating || null,
      reviewNumber: groupReviewNumber || null,
    };
  }

  return {
    rating: rating || null,
    reviewNumber: reviewNumber || null,
  };
}
